export const BNB_SCORE_BASE: number = 5; //* Fixed base for BNB instance
export const DEFAULT_SCORE_BASE: number = 10; //* Default base if none found

export enum SCORE_BASES {
  FIVE = 5,
  TEN = 10,
}

export interface ScoreBaseOption {
  name: string;
  value: SCORE_BASES;
  checked?: boolean;
}

export const SCORING_BASE_OPTIONS: ScoreBaseOption[] = [
  { name: '0-10', value: SCORE_BASES.TEN, checked: false },
  { name: '0-5', value: SCORE_BASES.FIVE, checked: false },
];

export interface MaturityBand {
  range: number; //* upper-bound raw score threshold for this maturity level
  value: number;
}

//* CMMI-style maturity bands, applied to the raw 0-10 score. Same shape used for the
//* default base-10 model and BnB/Mid-market/Beecher
export const DEFAULT_MATURITY_RANGES: MaturityBand[] = [
  { range: 0, value: 0 },
  { range: 1, value: 1 },
  { range: 2.5, value: 2 },
  { range: 5, value: 3 },
  { range: 7.5, value: 4 },
  { range: 10, value: 5 },
];

//* Equal-width maturity bands used when the entity's active scoring base is 0-5,
//* matching the actual maturity model shown to the user (e.g. a displayed score of 1.4/5 => Maturity 2)
export const FIVE_SCALE_MATURITY_RANGES: MaturityBand[] = [
  { range: 0, value: 0 },
  { range: 1, value: 1 },
  { range: 2, value: 2 },
  { range: 3, value: 3 },
  { range: 4, value: 4 },
  { range: 5, value: 5 },
];
